import React from "react";

function VersusComponent() {
    return (
        <div className="report--insights--versus">
            <span className="report--insights--versus-text">
                VS
            </span>
        </div>
    );
}

export default VersusComponent;
